import React from 'react';
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const FutbolPage = () => {
  // Use standardized gallery hook with consistent configuration
  const { getGalleryProps } = useStandardGallery('futbol');

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-futbol"></i>
          Futbol, Calcio, Soccer...
        </h1>
        <p>The Beautiful Game that unites the world! Football (or soccer) is the most popular sport globally, bringing together billions of fans across continents.</p>
      </div>

      <div className="page-content">
        {/* Personal Soccer Story - Hidden by default */}
        <div className="extended-intro">
          <div className="soccer-story">
            <h3><i className="fas fa-heart"></i> The Beautiful Game</h3>
            <p>The passion that I have for Futbol, the passion my family has for Futbol. I can't explain it, I can't put it into words, it's a feeling, it's a way of life, it's religion, politics, war & peace.</p>
          </div>
        </div>
        
        <div className="section">
          <p>
            The <b>Beautiful Game</b> that unites the world! Football (or soccer) is the most popular sport globally, bringing together billions of fans across continents. From the World Cup to local leagues, futbol represents passion, skill, teamwork, and the pure joy of competition on the pitch.
          </p>
        </div>

        {/* Futbol Gallery */}
        <div className="section">
          <UnifiedGallery 
            {...getGalleryProps("Futbol is Life")}
          />
        </div>
      </div>
    </div>
  );
};

export default FutbolPage;